import { render, staticRenderFns } from "./section3.vue?vue&type=template&id=45617d38"
import script from "./section3.vue?vue&type=script&lang=js"
export * from "./section3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports